import { EMPLOYEE_LOG, RESET_EMPLOYEE_LOG, EMPLOYEE_LOG_SUMMARY, RESET_EMPLOYEE_LOG_SUMMARY, EMPLOYEE_NAME, RESET_EMPLOYEE_NAME } from "../types"

const initialState = {
    data: [],
    summary: null,
    nameList: [],
    loading: false,
    error: null
}

const employeeLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case EMPLOYEE_LOG: {
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null
            }
        }

        case EMPLOYEE_LOG_SUMMARY: {
            return {
                ...state,
                summary: action.summary
            }
        }

        case EMPLOYEE_NAME: {
            return {
                ...state,
                nameList: action.data
            }
        }

        case RESET_EMPLOYEE_NAME: {
            return {
                ...state,
                nameList: []
            }
        }

        case RESET_EMPLOYEE_LOG: {
            return {
                ...initialState
            }
        }

        case RESET_EMPLOYEE_LOG_SUMMARY: {
            return {
                ...state,
                summary: null
            }
        }

        default: {
            return state
        }
    }
}

export default employeeLogReducer
